import Handlebars from 'handlebars';
let fullScreenLoaderWidget = require('../../../views/widgets/fullScreenLoaderWidget/tmpl/fullScreenLoaderWidget.hbs');
Handlebars.registerPartial('fullScreenLoaderWidget', fullScreenLoaderWidget);

class FullScreenLoaderService {
	create() {
		let template = `
			{{> fullScreenLoaderWidget
				wg="fullScreenLoaderWidget"
				ns="FullScreenLoaderWidget"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		let fullScreenLoaderWidgetTemplate = Handlebars.template(precompiled);

		$(document.body).append(fullScreenLoaderWidgetTemplate({}));
	}

	destroy() {
		$('.fullScreenLoaderWidget').remove();
	}
}

export let fullScreenLoaderService = new FullScreenLoaderService();
